import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=5e72cfb8&scoped=true&"
import script from "./BillingPage.vue?vue&type=script&lang=js&"
export * from "./BillingPage.vue?vue&type=script&lang=js&"
import style0 from "./BillingPage.vue?vue&type=style&index=0&id=5e72cfb8&scoped=true&lang=scss&"
import style1 from "./BillingPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72cfb8",
  null
  
)

export default component.exports